import { useAppTranslation } from "@/utils";
import { Flex, Typography } from "@payping/web-components";
import { FC } from "react";
import Draw from "./Draw";

interface SignatureProps {
  onFinish: () => void;
  goBack: () => void;
}
const BnplActivationPageFormSignature: FC<SignatureProps> = ({ onFinish, goBack }) => {
  const { t } = useAppTranslation();

  return (
    <Flex className="tw-w-full tw-p-8">
      <Flex vertical className="tw-w-full tw-max-w-[488px]" gap={"32px"}>
        <Typography.Title level={5} className="!tw-m-0">
          {t("shop.bnpl.activation.formDrawer.steps.signature.draw.title")}
        </Typography.Title>
        <Typography.Text>{t("shop.bnpl.activation.formDrawer.steps.signature.draw.content")}</Typography.Text>
        <Draw goBack={goBack} onFinish={onFinish} />
      </Flex>
    </Flex>
  );
};

export default BnplActivationPageFormSignature;
